import Logo from "../assets/images/logo.png";

export const Footer = () => {
  return (
    <footer>
      <div className=" grid md:grid-cols-[.8fr,1fr] p-6 sm:p-16 bg-neutral-50 gap-6  sm:place-items-end">
        <div className=" space-y-2">
          <a className=" flex space-x-2 items-center" href="/">
            <img
              className="md:h-[42px] h-[35px] md:w-[52px] w-[45px] "
              src={Logo}
            />
            <h2
              className=" tex-[20px] md:text-[25px] "
              style={{ fontFamily: "greenStalk" }}
            >
              Angry Bears
            </h2>
          </a>
          <p className=" text-sm text-zinc-400">
            Angry Bears is a bold and dynamic NFT project where untamed
            creativity meets the blockchain. Each Angry Bear is a unique,
            hand-crafted digital collectible designed to capture the raw, fierce
            energy of the project we are building on Bera chain
          </p>
          <p className=" text-sm text-zinc-400">
            Still in its early stages, the project aims to bring an immersive,
            community-driven experience to life, with engaging storytelling,
            exciting updates, and interactive events.
          </p>
        </div>

        <div className="flex gap-6 items-center text-zinc-400 text-sm">
          <p className=" border border-primary rounded-full px-3 p-2 text-primary">
            English
          </p>
          <p>Arabic</p>
          <p>French</p>
        </div>
      </div>

      <div className=" text-center text-sm text-zinc-400 pt-6 pb-10 border border-zinc-200 bg-zinc-50">
        Copyrighted © 2024 Angry Bears
      </div>
    </footer>
  );
};
